module.exports = __webpack_public_path__ + "static/media/galerija_2022_0005.3875f8fc.jpg";